define(['text!./templates/mfp-submit-button.html'], (templateStr) => {

    return [() => {
        return {
            restrict: 'E',
            scope: {
                labelKey: '=',
                mfpClick: '&',
                buttonClass: '=',
            },
            template: templateStr,
            controller: ['$scope', ($scope) => {
                $scope.submitButtonDisabled = false;
                $scope.handleClick = () => {
                    if ($scope.submitButtonDisabled) {
                        return;
                    }
                    const submitPromise = $scope.mfpClick();
                    if (submitPromise) {
                        $scope.submitButtonDisabled = true;
                        submitPromise.finally(() => {
                            $scope.submitButtonDisabled = false;
                        });
                    }
                };

            }],
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPSubmitButton.js